import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate
} from "react-router-dom";

import {
    FaUsers,
    FaUserCheck,
    FaCoins,
    FaPhotoVideo,
    FaUserEdit,
    FaVideo,
    FaFlag,
    FaArrowRight
} from "react-icons/fa";


const AdminDashboard = () => {

    const navigate =
        useNavigate();


    const [dashboard, setDashboard] =
        useState({
            totalUsers: 0,
            onlineUsers: 0,
            totalCoins: 0
        });


    const [momentStats, setMomentStats] =
        useState({
            activeMoments: 0,
            activeCreators: 0
        });


    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");


    useEffect(() => {

        const loadDashboard =
            async () => {

                try {

                    setLoading(true);
                    setError("");


                    const token =
                        localStorage.getItem(
                            "authToken"
                        );


                    const authHeader =
                        token?.startsWith(
                            "Bearer "
                        )
                            ? token
                            : `Bearer ${token}`;


                    const [
                        dashboardResponse,
                        momentResponse
                    ] =
                        await Promise.all([
                            fetch(
                                `${process.env.REACT_APP_API_URL}/api/admin/dashboard`,
                                {
                                    headers: {
                                        Authorization:
                                            authHeader
                                    }
                                }
                            ),

                            fetch(
                                `${process.env.REACT_APP_API_URL}/api/admin/moments/stats`,
                                {
                                    headers: {
                                        Authorization:
                                            authHeader
                                    }
                                }
                            )
                        ]);


                    if (
                        !dashboardResponse.ok
                    ) {

                        if (
                            dashboardResponse.status ===
                                401 ||
                            dashboardResponse.status ===
                                403
                        ) {

                            throw new Error(
                                "You are not authorized to access the admin dashboard."
                            );
                        }

                        throw new Error(
                            "Unable to load admin dashboard."
                        );
                    }


                    const dashboardData =
                        await dashboardResponse
                            .json();


                    setDashboard({
                        totalUsers:
                            Number(
                                dashboardData
                                    ?.totalUsers ||
                                0
                            ),

                        onlineUsers:
                            Number(
                                dashboardData
                                    ?.onlineUsers ||
                                0
                            ),

                        totalCoins:
                            Number(
                                dashboardData
                                    ?.totalCoins ||
                                0
                            )
                    });


                    if (
                        momentResponse.ok
                    ) {

                        const momentData =
                            await momentResponse
                                .json();


                        setMomentStats({
                            activeMoments:
                                Number(
                                    momentData
                                        ?.activeMoments ||
                                    0
                                ),

                            activeCreators:
                                Number(
                                    momentData
                                        ?.activeCreators ||
                                    0
                                )
                        });
                    }


                } catch (error) {

                    console.error(
                        "Admin dashboard error:",
                        error
                    );

                    setError(
                        error.message ||
                        "Unable to load dashboard."
                    );

                } finally {

                    setLoading(false);
                }
            };


        loadDashboard();

    }, []);


    if (loading) {

        return (

            <div
                style={{
                    minHeight:
                        "calc(100vh - 70px)",

                    display:
                        "flex",

                    justifyContent:
                        "center",

                    alignItems:
                        "center",

                    background:
                        "#f6f7fb"
                }}
            >

                <div
                    style={{
                        background:
                            "#fff",

                        padding:
                            "25px 35px",

                        borderRadius:
                            "18px",

                        boxShadow:
                            "0 10px 35px rgba(0,0,0,0.07)",

                        fontWeight:
                            "700",

                        color:
                            "#555"
                    }}
                >
                    Loading dashboard...
                </div>

            </div>
        );
    }


    if (error) {

        return (

            <div
                style={{
                    padding:
                        "40px",

                    background:
                        "#f6f7fb",

                    minHeight:
                        "100vh"
                }}
            >

                <div
                    style={{
                        background:
                            "#fff",

                        border:
                            "1px solid #fecaca",

                        color:
                            "#b91c1c",

                        padding:
                            "20px",

                        borderRadius:
                            "16px"
                    }}
                >

                    <strong>
                        Admin Dashboard
                    </strong>

                    <div
                        style={{
                            marginTop:
                                "8px"
                        }}
                    >
                        {error}
                    </div>

                </div>

            </div>
        );
    }


    return (

        <div
            style={{
                width: "100%",

                minHeight:
                    "calc(100vh - 70px)",

                background:
                    "#f6f7fb",

                padding:
                    "32px",

                boxSizing:
                    "border-box"
            }}
        >

            <div
                style={{
                    maxWidth:
                        "1300px",

                    margin:
                        "0 auto"
                }}
            >

                {/* HEADER */}

                <div
                    style={{
                        display:
                            "flex",

                        justifyContent:
                            "space-between",

                        alignItems:
                            "center",

                        gap:
                            "20px",

                        flexWrap:
                            "wrap",

                        marginBottom:
                            "32px"
                    }}
                >

                    <div>

                        <div
                            style={{
                                display:
                                    "inline-flex",

                                alignItems:
                                    "center",

                                gap:
                                    "8px",

                                background:
                                    "#fff0f5",

                                color:
                                    "#ff4f88",

                                padding:
                                    "7px 13px",

                                borderRadius:
                                    "999px",

                                fontSize:
                                    "12px",

                                fontWeight:
                                    "800",

                                marginBottom:
                                    "12px"
                            }}
                        >
                            ADMIN PANEL
                        </div>


                        <h1
                            style={{
                                margin: 0,

                                fontSize:
                                    "34px",

                                fontWeight:
                                    "850",

                                color:
                                    "#18181b"
                            }}
                        >
                            MyHalal Dashboard
                        </h1>


                        <p
                            style={{
                                margin:
                                    "8px 0 0",

                                color:
                                    "#71717a",

                                fontSize:
                                    "15px"
                            }}
                        >
                            Platform overview and moderation center
                        </p>

                    </div>


                    <button
                        type="button"

                        onClick={() =>
                            navigate(
                                "/admin/users"
                            )
                        }

                        style={{
                            border:
                                "none",

                            background:
                                "linear-gradient(135deg, #ff5f91, #ff3d77)",

                            color:
                                "#fff",

                            padding:
                                "13px 20px",

                            borderRadius:
                                "13px",

                            cursor:
                                "pointer",

                            fontWeight:
                                "800",

                            fontSize:
                                "14px",

                            boxShadow:
                                "0 8px 20px rgba(255,95,145,.25)"
                        }}
                    >

                        Manage Users

                    </button>

                </div>


                {/* STAT CARDS */}

                <div
                    style={{
                        display:
                            "grid",

                        gridTemplateColumns:
                            "repeat(auto-fit, minmax(220px, 1fr))",

                        gap:
                            "18px"
                    }}
                >

                    <StatCard
                        title="Total Users"
                        value={
                            dashboard.totalUsers
                        }
                        subtitle="Registered accounts"
                        icon={
                            <FaUsers />
                        }
                        accent="#ff5f91"
                        background="#fff0f5"
                    />


                    <StatCard
                        title="Online Users"
                        value={
                            dashboard.onlineUsers
                        }
                        subtitle="Currently online"
                        icon={
                            <FaUserCheck />
                        }
                        accent="#16a34a"
                        background="#ecfdf3"
                    />


                    <StatCard
                        title="Total Coins"
                        value={
                            dashboard.totalCoins
                        }
                        subtitle="Coins in circulation"
                        icon={
                            <FaCoins />
                        }
                        accent="#d97706"
                        background="#fff7ed"
                    />


                    <StatCard
                        title="Active Moments"
                        value={
                            momentStats.activeMoments
                        }
                        subtitle="Currently available"
                        icon={
                            <FaPhotoVideo />
                        }
                        accent="#7c3aed"
                        background="#f5f3ff"
                    />


                    <StatCard
                        title="Moment Creators"
                        value={
                            momentStats.activeCreators
                        }
                        subtitle="Users with active Moments"
                        icon={
                            <FaUserEdit />
                        }
                        accent="#2563eb"
                        background="#eff6ff"
                    />

                </div>


                {/* QUICK ACTIONS */}

                <div
                    style={{
                        marginTop:
                            "38px"
                    }}
                >

                    <div
                        style={{
                            marginBottom:
                                "18px"
                        }}
                    >

                        <h2
                            style={{
                                margin: 0,

                                fontSize:
                                    "22px",

                                color:
                                    "#18181b"
                            }}
                        >
                            Quick Actions
                        </h2>

                        <p
                            style={{
                                margin:
                                    "6px 0 0",

                                color:
                                    "#71717a",

                                fontSize:
                                    "14px"
                            }}
                        >
                            Manage the most important areas of the platform
                        </p>

                    </div>


                    <div
                        style={{
                            display:
                                "grid",

                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(240px, 1fr))",

                            gap:
                                "16px"
                        }}
                    >

                        <ActionCard
                            title="Users"
                            description="Manage accounts, suspensions and bans."
                            icon={
                                <FaUsers />
                            }
                            onClick={() =>
                                navigate(
                                    "/admin/users"
                                )
                            }
                        />


                        <ActionCard
                            title="Reports"
                            description="Review reported users and content."
                            icon={
                                <FaFlag />
                            }
                            onClick={() =>
                                navigate(
                                    "/admin/reports"
                                )
                            }
                        />


                        <ActionCard
                            title="Live Moderation"
                            description="Monitor and stop active live sessions."
                            icon={
                                <FaVideo />
                            }
                            onClick={() =>
                                navigate(
                                    "/admin/live"
                                )
                            }
                        />

                    </div>

                </div>


                {/* SYSTEM SUMMARY */}

                <div
                    style={{
                        marginTop:
                            "38px",

                        background:
                            "linear-gradient(135deg, #18181b, #27272a)",

                        color:
                            "#fff",

                        borderRadius:
                            "22px",

                        padding:
                            "26px",

                        display:
                            "flex",

                        justifyContent:
                            "space-between",

                        alignItems:
                            "center",

                        gap:
                            "20px",

                        flexWrap:
                            "wrap"
                    }}
                >

                    <div>

                        <div
                            style={{
                                fontSize:
                                    "13px",

                                opacity:
                                    0.7,

                                marginBottom:
                                    "7px"
                            }}
                        >
                            PLATFORM STATUS
                        </div>

                        <div
                            style={{
                                fontSize:
                                    "22px",

                                fontWeight:
                                    "800"
                            }}
                        >
                            MyHalal Administration
                        </div>

                        <div
                            style={{
                                marginTop:
                                    "7px",

                                fontSize:
                                    "14px",

                                opacity:
                                    0.75
                            }}
                        >
                            Monitor users, reports, live sessions and platform activity.
                        </div>

                    </div>


                    <div
                        style={{
                            background:
                                "rgba(255,255,255,.10)",

                            border:
                                "1px solid rgba(255,255,255,.14)",

                            borderRadius:
                                "999px",

                            padding:
                                "9px 15px",

                            fontSize:
                                "13px",

                            fontWeight:
                                "800"
                        }}
                    >
                        ● System Active
                    </div>

                </div>

            </div>

        </div>
    );
};



const StatCard = ({
    title,
    value,
    subtitle,
    icon,
    accent,
    background
}) => {

    return (

        <div
            style={{
                background:
                    "#fff",

                borderRadius:
                    "20px",

                padding:
                    "22px",

                border:
                    "1px solid #eeeeF2",

                boxShadow:
                    "0 8px 28px rgba(15,23,42,.05)",

                transition:
                    "transform .2s ease"
            }}
        >

            <div
                style={{
                    display:
                        "flex",

                    justifyContent:
                        "space-between",

                    alignItems:
                        "center",

                    gap:
                        "15px"
                }}
            >

                <div>

                    <div
                        style={{
                            color:
                                "#71717a",

                            fontSize:
                                "13px",

                            fontWeight:
                                "700"
                        }}
                    >
                        {title}
                    </div>


                    <div
                        style={{
                            fontSize:
                                "32px",

                            fontWeight:
                                "850",

                            color:
                                "#18181b",

                            marginTop:
                                "8px"
                        }}
                    >
                        {value ?? 0}
                    </div>

                </div>


                <div
                    style={{
                        width:
                            "48px",

                        height:
                            "48px",

                        borderRadius:
                            "15px",

                        display:
                            "flex",

                        justifyContent:
                            "center",

                        alignItems:
                            "center",

                        fontSize:
                            "20px",

                        color:
                            accent,

                        background:
                            background
                    }}
                >
                    {icon}
                </div>

            </div>


            <div
                style={{
                    marginTop:
                        "16px",

                    paddingTop:
                        "14px",

                    borderTop:
                        "1px solid #f1f1f4",

                    color:
                        "#a1a1aa",

                    fontSize:
                        "12px"
                }}
            >
                {subtitle}
            </div>

        </div>
    );
};



const ActionCard = ({
    title,
    description,
    icon,
    onClick
}) => {

    return (

        <button
            type="button"

            onClick={
                onClick
            }

            style={{
                width:
                    "100%",

                border:
                    "1px solid #ececf1",

                background:
                    "#fff",

                padding:
                    "20px",

                borderRadius:
                    "18px",

                cursor:
                    "pointer",

                textAlign:
                    "left",

                display:
                    "flex",

                alignItems:
                    "center",

                gap:
                    "15px",

                boxShadow:
                    "0 5px 20px rgba(15,23,42,.04)"
            }}
        >

            <div
                style={{
                    width:
                        "44px",

                    height:
                        "44px",

                    minWidth:
                        "44px",

                    borderRadius:
                        "14px",

                    background:
                        "#fff0f5",

                    color:
                        "#ff5f91",

                    display:
                        "flex",

                    justifyContent:
                        "center",

                    alignItems:
                        "center",

                    fontSize:
                        "18px"
                }}
            >
                {icon}
            </div>


            <div
                style={{
                    flex: 1
                }}
            >

                <div
                    style={{
                        fontWeight:
                            "800",

                        color:
                            "#18181b",

                        fontSize:
                            "15px"
                    }}
                >
                    {title}
                </div>


                <div
                    style={{
                        color:
                            "#71717a",

                        fontSize:
                            "12px",

                        marginTop:
                            "4px",

                        lineHeight:
                            "1.5"
                    }}
                >
                    {description}
                </div>

            </div>


            <FaArrowRight
                style={{
                    color:
                        "#a1a1aa",

                    fontSize:
                        "13px"
                }}
            />

        </button>
    );
};


export default AdminDashboard;